import { types } from "../types/types";

const initialState = {
  companyList: {},
  selectedCompany: {},
  getLoadingState: {},
  updateCompanyNeeded: {},
  reportGroupCompanyIds: [],
  /** Cuando true, reportes consolidados excluyen DTEs entre empresas del grupo. */
  excludeIntercompanyReports: true,
};

export const companyListReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.getCompanyList:
      return {
        ...state,
        companyList: [...action.payload],
      };
    case types.selectedCompany:
      return {
        ...state,
        selectedCompany: {
          ...action.payload,
        },
      };
    case types.getLoadingState:
      return {
        ...state,
        getLoadingState: {
          ...action.payload,
        },
      };
    case types.authLogout:
      return {
        ...initialState,
      };
    case types.getUpdateCompanyNeeded:
      return {
        ...state,
        updateCompanyNeeded: { ...action.payload },
      };
    case types.setReportGroupCompanyIds:
      return {
        ...state,
        reportGroupCompanyIds: Array.isArray(action.payload)
          ? [...action.payload]
          : [],
      };
    case types.setExcludeIntercompanyReports:
      return {
        ...state,
        excludeIntercompanyReports: Boolean(action.payload),
      };
    default:
      return state;
  }
};
